"use client";
import React, { useEffect, useState } from "react";
import { getLocalIdentity } from "@meitu/xdesign-identity";
import {
  jumpToLogin,
  handleLogout,
  getUserInfo,
  openVipModal,
  getCallback,
} from "@/utils/login";
import { statTrack } from "@/utils/mtstat";
import dynamic from "next/dynamic";
import { UserInfoType } from "@meitu/xdesign-widgets/dist/types/userInfo";
import { MeidouInfoType } from "@meitu/xdesign-widgets/dist/types/meidouInfo";
import { CutoutInfo } from "@meitu/xdesign-widgets/dist/types/cutout";

const UserInfo = dynamic(() => import("@meitu/xdesign-widgets/dist/userInfo"), {
  ssr: false,
});

interface UserInfoProps {
  userInfo?: UserInfoType;
  meidouInfo?: MeidouInfoType | null;
  cutoutInfo?: CutoutInfo | null;
}

const User = ({ userInfo, meidouInfo, cutoutInfo }: UserInfoProps) => {
  const [callback, setCallback] = useState<string>("");

  const handleOpenVip = () => {
    openVipModal({
      entrance: "open",
      subscribe_type: getLocalIdentity()?.oid ? "subscription" : undefined,
    });
  };

  useEffect(() => {
    setCallback(getCallback());
  }, []);

  return (
    <UserInfo
      userInfo={userInfo}
      callback={callback}
      avatarSize={34}
      meidouAmount={meidouInfo?.available_amount}
      cutoutAmount={cutoutInfo?.left}
      onLogin={jumpToLogin}
      onLogout={handleLogout}
      onOpenVipModal={handleOpenVip}
      track={statTrack}
      onExchangeSuccess={getUserInfo}
    />
  );
};

export default React.memo(User);
